<template>
  <div>
    <christmas-lights ref="christmasLights" v-if="isChristmasTime"></christmas-lights>
    <banner v-if="showBanners && slides.length>0" :slides="slides" :key="mfID" :isChristmasTime="isChristmasTime" :startingSlide="slideStartsAt"></banner>
    <modal-learn-more v-if="showLearnModal" @close="closeLearnMore"></modal-learn-more>
  </div>
</template>

<script>
import moment from 'moment'

import ModalLearnMore from '@/components/Modals/LearnMore'
import ChristmasLights from '@/components/Controls/ChristmasLights'

import vmfBanner from './vmfBanner'
import Banner from './Banner'

import breakpoints from '@/libs/breakpoints'
import auth from '@/mixins/auth'
import utmTracking from '@/mixins/utm-tracking'
import categorySets from '@/mixins/category-set'

export default {
  mixins: [auth, vmfBanner, utmTracking, categorySets],
  components: {
    Banner,
    ModalLearnMore,
    ChristmasLights
  },
  data: function () {
    return {
      category: '',
      categoryID: 0,
      slides: [],
      currentSlide: 0,
      showBanners: false,
      banners: [],
      categoryBanners: [],
      showLearnModal: false,
      startingSlide: 1,
      singleStartingSlide: 1,
      mfID: 0,
      bannerSetName: '',
      bannerSets: [],
      bannerSetButtons: []
    }
  },
  computed: {
    slideStartsAt: function () {
      const slideStartAt = this.startingSlide
      return slideStartAt
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    isCategoryBanner: function () {
      return this.singleSlide.filter(slide => (slide.category === this.$route.params.category)).length === 1
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    isChristmasTime: function () {
      const holidayPeriodStart = `${moment().year()}-12-15`
      const holidayPeriodEnd = `${moment().year()}-12-31`
      return moment().isAfter(holidayPeriodStart) && moment().isBefore(holidayPeriodEnd)
    }
  },
  watch: {
    $route () {
      this.getSlides()
    }
  },
  mounted () {
    this.getSlides()
  },
  methods: {
    reset: function () {
      this.showBanners = false
      this.slides = []
    },
    getSlides: async function () {
      this.reset()
      await this.getCategoryObj()
      if (this.categoryID === 0) {
        if (this.$route.path.includes('discover')) {
          this.bannerSetName = this.appName + '-' + this.$route.name + '-' + this.$route.params.discoverpage.toLowerCase()
          this.bannerSets = await this.getBannerSetForNonCategoryPage(this.bannerSetName)
          this.bannerSetButtons = await this.getBannerButtonsForNonCategoryPage(this.bannerSetName)
          if (this.bannerSetButtons === undefined) {
            this.bannerSetButtons = []
          }
          this.showBanners = true
        } else if (this.$route.path.includes('explore')) {
          this.bannerSetName = this.appName + '-' + this.$route.name + '-' + this.$route.params.explorepage.toLowerCase()
          this.bannerSets = await this.getBannerSetForNonCategoryPage(this.bannerSetName)
          this.bannerSetButtons = await this.getBannerButtonsForNonCategoryPage(this.bannerSetName)
          if (this.bannerSetButtons === undefined) {
            this.bannerSetButtons = []
          }
          this.showBanners = true
        } else if (this.$route.path === '/home' || this.$route.path === '/viewAll') {
          this.bannerSets = await this.getCategorySetsForCategoryPage(this.appName, 0)
          this.bannerSetButtons = await this.getBannerButtonsForCategoryPage(this.appName, 0)
        } else {
          return
        }
      } else {
        this.bannerSets = await this.getCategorySetsForCategoryPage(this.appName, this.categoryID)
        this.bannerSetButtons = await this.getBannerButtonsForCategoryPage(this.appName, this.categoryID)
      }

      let btnCheck = false
      for (let i = 0; i < this.bannerSets.length; i++) {
        // Initialize JSON
        const emp = {}

        emp.id = this.bannerSets[i].id
        emp.title = {
          title: this.bannerSets[i].title,
          image: this.bannerSets[i].image,
          imageAltText: this.bannerSets[i].imageAltText
        }
        emp.description = this.bannerSets[i].description
        emp.background = {
          image: this.bannerSets[i].background_image
        }
        for (let j = 0; j < this.bannerSetButtons.length; j++) {
          if (this.bannerSets[i].id === parseInt(this.bannerSetButtons[j].banner_id)) {
            emp.content = {}
            emp.content.link = {}
            emp.content.button = {}
            if (!btnCheck) {
              emp.content.link.show = true
              emp.content.link.text = this.bannerSetButtons[j].text
              emp.content.link.url = this.bannerSetButtons[j].link
              emp.content.link.paramName = this.bannerSetButtons[j].option_name
              emp.content.link.paramValue = this.bannerSetButtons[j].option_value
              btnCheck = true
            } else {
              emp.content.button.show = true
              emp.content.button.text = this.bannerSetButtons[j].text
              emp.content.button.url = this.bannerSetButtons[j].link
              emp.content.button.paramName = this.bannerSetButtons[j].option_name
              emp.content.button.paramValue = this.bannerSetButtons[j].option_value
              btnCheck = false
            }
          }
        }
        btnCheck = false
        this.slides.push(emp)
      }
    },
    getCategoryObj: async function () {
      if (this.$route.params.category && this.$route.params.category.length > 0) {
        this.category = this.$route.params.category
      } else {
        this.category = this.$route.query.category
      }
      try {
        this.categoryObj = await this.getShowBannerForCategoryFlag(this.category)
        if (this.categoryObj === null) {
          if (this.$route.path === '/home' || this.$route.path === '/viewAll') {
            this.showBanners = true
          } else {
            this.showBanners = false
          }
        } else {
          this.categoryID = this.categoryObj.id
          this.showBanners = this.categoryObj.showBanner
        }
      } catch (error) {
        console.error(error)
      }
    },
    contactUs: function () {
      this.$router.push('/contact/?source=makerfaire')
    },
    openRoute: function (url) {
      this.$router.push(url)
    },
    directToEducation: function () {
      window.open(this.getUTMLink('https://www.partners.engineering.com/schools', 'banner')
        , '_system')
    },
    Faq: function () {
      this.$router.push('/FAQ')
    },
    fablabPage: function () {
      this.$router.push('/makerspacechallenge')
    },
    startNow: function () {
      this.$emit('start')
    },
    showSignup: function () {
      this.$store.dispatch('showLoginModal', { source: 'LOGIN:{PATH}' })
    },
    openLearnMore: function () {
      this.showLearnModal = true
      this.$store.dispatch('showLearnMoreModal')
    },
    closeLearnMore: function () {
      this.showLearnModal = false
    },
    learnAboutMakerFaireURL: function () {
      window.open('https://makeprojects.com/category/maker-faires')
    },
    learnMoreGrowingBeyondEarthURL: function () {
      window.open('/')
    },
    enterNowGrowingBeyondEarthURL: function () {
      window.open('https://make.co/grow')
    },
    mpGermanyURL: function () {
      window.open(this.getUTMLink('https://maker-faire.de/hannover', 'banner'))
    },
    smartHomeChallengeURL: function () {
      window.open('https://makeprojects.com/de/viewAll?category=smart-home-challenge')
    },
    lassDieFunkenFliegenURL: function () {
      window.open('https://makeprojects.com/de/viewAll?category=lass-die-funken-fliegen')
    },
    enterNow: function (startProjectDetails) {
      const partner = this.$partner ? this.$partner : 'make'
      const baseURL = this.$webRoot + '/' + partner
      let projectTemplateURL = '/start/template?projectID=' + startProjectDetails.projectID + '&startButton=true'
      if (startProjectDetails.isDraft) {
        projectTemplateURL = projectTemplateURL + '&draft=true'
      }
      if (startProjectDetails.isPrivate) {
        projectTemplateURL = projectTemplateURL + '&private=true'
      }
      if (startProjectDetails.isHidden) {
        projectTemplateURL = projectTemplateURL + '&hidden=true'
      }
      if (!this.isMobile) {
        window.open(baseURL + projectTemplateURL)
      } else {
        this.$router.push(projectTemplateURL)
      }
    },
    learnMoreUrl: function (Url) {
      this.$router.push(Url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.capitalize {
  text-transform: capitalize;
}

::v-deep .title {
  width: 100%;
  font-weight: 700;
  font-size: 2.6rem;
  line-height: 3.2rem;
  letter-spacing: 0.1rem;
  color: white;
  padding-bottom: 1.2rem;
  margin-bottom: 0;
  text-align: left;
}

::v-deep .slide9 .description strong {
  color: #fff;
}

::v-deep .slide10 {
  button {
    line-height: 1rem;
  }
}

::v-deep .slide10 {
  .description {
    width: 95%;
  }
}

// growingBeyondEarth
::v-deep .slide12 {
  .title {
    font-size: 2.2rem;
  }

  .description {
    width: 100%;
  }

  @media (max-width: 410px) {
    .description {
      line-height: 1.4rem;
    }
  }
}

@media (max-width: 767px) {
  .text .title {
    font-size: 2.6rem;
  }
}

@media (max-width: 550px) {
  .text .title {
    font-size: 2.3rem;
  }
  .title {
    text-align: center;
  }
  .text {
    margin: auto;
    width: 85%;
  }
  .link-container {
    margin-top: 0.5rem;
  }
  .link {
    margin: 1.5rem auto;
  }
}

@media (max-width: 430px) {
  .description {
    &:before {
      margin: 0 38%;
    }
  }
  .title {
    padding-bottom: 1rem;
  }
  .description {
    line-height: 1.25rem;
  }
}

::v-deep .slide8 {
  color: black;

  &.background-image {
    background-position: right;
  }

  @media (max-width: 1200px) {
    &.background-image {
      background-position: 88%;
    }
  }

  .text {
    margin: auto;
    width: 85%;
  }

  .link {
    margin: 1.5rem auto;
  }

  .description {
    text-align: center;
    width: 100%;
    margin: 0 auto;
    font-size: 0.95rem;
    padding: 3% 9.5% 0% 9.5%;

    &:before {
      margin: 0 45%;
    }
  }
}

@media (max-width: 550px) {
  .description {
    padding: 5% 7% 0% 7%;

    &:before {
      margin: 0 44%;
    }
  }
}

@media (max-width: 350px) {
  .description {
    &:before {
      margin: 0 38%;
    }
  }
}

.link-container {
  display: flex;
  width: 100%;

  .right-button {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:focus,
    &:focus-within,
    &:active {
      outline: 0;
    }
  }

  .padding-right {
    margin-left: 0.7rem;
  }

  i {
    padding-right: 0.3rem;
  }
}

.is-flex {
  flex-direction: column;
}

.data-container-pbplus {
  width: 100vw;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-end;
  align-items: center;
  margin-left: -8rem;
  @media (max-width: 1024px) {
    margin-top: 0rem;
  }
  @media (max-width: 450px) {
    margin-left: -1.4rem;
  }
}

.logo-container-pbplus {
  height: 17rem;
  width: 34rem;
  @media (max-width: 1024px) {
    height: 17rem;
    width: 34rem;
  }
  @media (max-width: 820px) {
    height: 17rem;
    width: 30rem;
  }
  @media (max-width: 550px) {
    height: 17rem;
    width: 25rem;
    margin-left: 10.8rem;
  }
  @media (max-width: 450px) {
    height: 17rem;
    width: 20rem;
    margin-right: 12.1rem;
  }
}

.link {
  font-size: 0.9rem;
  letter-spacing: 0.1rem;
  text-align: center;
  margin-top: 1.5rem;
  border-radius: 0;
  border: none;
  background: $primary;
  color: white;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);

  .vmf-link {
    background: none;
    border: 2px solid white;

    &:hover,
    &:focus,
    &:active {
      background: $primary;
    }
  }

  &:hover,
  &:focus,
  &:active {
    background: $link-hover;
  }
}

@media (max-width: 850px) {
  ::v-deep .slide10 {
    background-position: 35%;
  }
}

@include mobile {
  ::v-deep .slide9 {
    background-position: 0;
  }
  ::v-deep .text .title {
    font-size: 1.8rem;
    line-height: 2.5rem;
    padding-bottom: 0.7rem;
  }
  ::v-deep .description {
    width: 90%;
    font-size: 0.95rem;
    line-height: 1.4rem;
  }
  ::v-deep .slide10 {
    .description {
      width: 100%;
      padding-top: 1rem;
    }
  }
  ::v-deep .slide11 {
    background-position: 25%;

    .description {
      width: 100%;
    }
  }
}

@media (max-width: 700px) {
  ::v-deep .slide11 {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0)), url('/static/make/banner/makerfaire.jpg') !important;
    background-position: 40%;

    .description {
      width: 85%;
    }
  }
}

@media (max-width: 550px) {
  ::v-deep .slide9 {
    background-position: 55%;

    .description {
      width: 80%;
    }
  }
}

@media (max-width: 480px) {
  ::v-deep .slide11 {
    background-position: 60%;
  }
  ::v-deep .slide10 {
    .description {
      width: 100%;
    }
  }
}

@media (max-width: 430px) {
  ::v-deep .slide9 {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.2)), url('/static/make/banner/makerfaire.jpg');
    background-position: 60%;
  }
  ::v-deep .slide10 {
    background-position: 47%;
  }
  ::v-deep .slide9, .slide10, .slide11 {
    .description {
      width: 100%;
    }
  }
  ::v-deep .text .title {
    font-size: 1.4rem;
    line-height: 1.6rem;
  }
  ::v-deep .description {
    font-size: 0.85rem;
    line-height: 1rem;
  }
}

@media (max-width: 390px) {
  ::v-deep .slide12 {
    .title {
      padding-bottom: 0.5rem;
    }

    .description {
      padding-top: 0.5rem;
    }

    .link {
      margin-top: 0.5rem;
    }
  }
}

@media (max-width: 374px) {
  ::v-deep .slides {
    min-height: 24rem;
  }
  ::v-deep .slide9, .slide10, .slide11 {
    .description {
      width: 100%;
    }
  }
}

</style>
